import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import logoImg from '../../../assets/img/icon-bot.png';

const Form = () => {

  const { t } = useTranslation();

  const formField = useRef(null);

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [valid, setIsValid] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if(formField.current){
      setIsValid(formField.current.checkValidity());
    }

  }, [name, phone, email, message]);

  const onClick = async (e) => {
    e.preventDefault();
    setError(false);

    const { data } = await axios.post('/email', {
      name,
      email,
      phone,
      message
    });

    if (data.errors) {
      setError(data.errors[0].message);
    } else {
      if(data.success === false){
        setError(t('form.unknown_error'));
      }
      else{
        setName('');
        setEmail('');
        setMessage('');
        setPhone('');
        setSuccess(true);
      }
    }
  };

  return (
    <div className="chat-form email-form">

      {success && (
      <div className="chat-form-header">
        <div className="chat-form-header--img">
          <img src={logoImg} />
        </div>
        <div className="chat-form-header--text">{t('form.success')}</div>
      </div>
      )}

      <form ref={formField}>
      <div className="control-group">
        <label htmlFor="name" className="control-label">{t('form.name')}</label>
        <input required={true} id="name" type="text" placeholder={t('form.your_name')} value={name}
               onChange={(e) => setName(e.target.value)} />
      </div>

      <div className="control-group">
        <label htmlFor="phone" className="control-label">{t('form.phone')}</label>
        <input required={true} id="phone" type="text" placeholder={t('form.phone_placeholder')} value={phone}
               pattern="^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$" minLength={7}
               onChange={(e) => setPhone(e.target.value)} />
      </div>

      <div className="control-group">
        <label htmlFor="email" className="control-label">{t('form.email')}</label>
        <input required={true} id="email" type="email" placeholder={t('form.your_email')} value={email}
               onChange={(e) => setEmail(e.target.value)} />
      </div>

      <div className="control-group">
        <label htmlFor="message" className="control-label">{t('form.message')}</label>
        <textarea required={true} placeholder={t('form.your_question')} id="message" rows="8" cols="50" onChange={(e) => setMessage(e.target.value)} value={message} />
      </div>
      {error && (
        <div className="error">{error}</div>
      )}
      <div className="confirm">
        <button type="submit" onClick={onClick} disabled={!valid}>{t('form.send_message')}</button>
      </div>
      </form>
    </div>
  );
};


export default Form;
